import React, { Component } from 'react';
import './css/index.css';
import img from '../../../assets/images/newLogo.png';
import Layout from '../../../components/Layout';
import InpersonregForm from './InpersonReg';

class Inpersonreg extends Component {
  render() {
    return (
      <Layout {...this.props}>
        <div className="folder">
          <div className="file">
            <div className="imageField">
              <img src={img} alt="logo" />
            </div>

            <div className="this">
              <h1>
                <span>PACKAGE:</span> PHYSICAL TRAINING
              </h1>
              <h2>Registration & Payment</h2>
              <div className="accForm newaccform">
                <div className="fieldContent">
                  <InpersonregForm price="500" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default Inpersonreg;
